import { defineStore, storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import { useImagesStore } from './imagesStore'
import type { Ref } from 'vue'
import type { WaypointType } from 'Modules/types/pages/imageReview/waypoint'

export const useWaypointsStore = defineStore('ImageReview_waypoints', () => {
  //State
  const imagesStore = useImagesStore()
  const { currentImage } = storeToRefs(imagesStore)
  const waypointsData: Ref<Array<WaypointType>> = ref([])

  //Getters
  const currentWaypoint = computed<WaypointType>(() => {
    return waypointsData.value.find((waypoint: WaypointType) => waypoint.uuid === currentImage.value?.waypointUuid)
  })

  //Actions
  function setWaypointsData(waypoints: Array<WaypointType>) {
    waypointsData.value = waypoints
  }

  return {
    currentWaypoint,
    waypointsData,
    setWaypointsData,
  }
})
